/* Google Maps consent — loaded independently of the site's UI interactions. */
(() => {
  const maps = document.querySelectorAll('.footer__map');
  if (!maps.length) return;

  window._axcb = window._axcb || [];
  window._axcb.push(sdk => {
    const updateMaps = choices => {
      const accepted = choices?.gmaps === true;
      maps.forEach(map => {
        const frame = map.querySelector('[data-map-frame]');
        const placeholder = map.querySelector('[data-map-placeholder]');
        if (accepted) {
          if (frame.getAttribute('src') !== frame.dataset.src) {
            frame.setAttribute('src', frame.dataset.src);
          }
        } else {
          frame.removeAttribute('src');
        }
        frame.hidden = !accepted;
        placeholder.hidden = accepted;
      });
    };

    sdk.on('cookies:complete', updateMaps);
    // Restore saved choices even if the SDK initialized before this deferred script.
    updateMaps(sdk.userPreferencesManager?.choices);
    maps.forEach(map => {
      const button = map.querySelector('[data-map-consent]');
      button.disabled = false;
      button.addEventListener('click', () => sdk.requestConsent('gmaps'));
    });
  });
})();
